import { ComposerTranslation } from 'vue-i18n';

export interface TenantPlusEngagementModalTranslations {
  header: string;
  benefits: {
    benefit1: string;
    benefit2: string;
    benefit3: string;
  };
  startFreeTrialCTA: string;
  learnMoreCTA: string;
  price: string;
  acknowledgedCTA: string;
}

export function useTenantPlusEngagementModal(t: ComposerTranslation): {
  translations: TenantPlusEngagementModalTranslations;
} {
  return {
    translations: {
      header: t('tenantPlus.tenantPlusEngagementModal.header'),
      benefits: {
        benefit1: t('tenantPlus.tenantPlusEngagementModal.benefits.benefit1'),
        benefit2: t('tenantPlus.tenantPlusEngagementModal.benefits.benefit2'),
        benefit3: t('tenantPlus.tenantPlusEngagementModal.benefits.benefit3'),
      },
      startFreeTrialCTA: t('tenantPlus.tenantPlusEngagementModal.startFreeTrialCTA'),
      learnMoreCTA: t('tenantPlus.tenantPlusEngagementModal.learnMoreCTA'),
      price: t('tenantPlus.tenantPlusEngagementModal.variable.price'),
      acknowledgedCTA: t('tenantPlus.tenantPlusEngagementModal.acknowledgedCTA'),
    },
  };
}
